"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIGatewayHeaders = void 0;
const tslib_1 = require("tslib");
const apigw_models_1 = require("@integration/apigw-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
require("reflect-metadata");
const errors_1 = require("../errors");
/**
 * Axway Headers, as injected by axway
 */
class APIGatewayHeaders extends apigw_models_1.Serializable {
    /**
     * Gets the accountId and performs usage & permission validations
     * @param request
     * @returns
     */
    static getAccountId(request) {
        const accountIdQuery = request.query?.accountId;
        const accountIdPath = request.path?.accountId;
        // LambdaManager.transformObjectKeysToLowerCase transforms header keys to lowercase (!)
        const accountIdHeader = request.headers?.accountId || request.headers?.accountid;
        const cockpitAccountId = request.headers?.cockpitAccountId;
        const accountId = accountIdPath || accountIdQuery || accountIdHeader || cockpitAccountId;
        if (!accountId) {
            throw new errors_1.InputValidationError('Missing accountId');
        }
        if ((accountIdHeader && accountIdHeader !== accountId) ||
            (cockpitAccountId && cockpitAccountId !== accountId)) {
            throw new errors_1.UnauthorizedError('You are not authorized to view data for this account');
        }
        if (accountId.length === 9) {
            return `0${accountId}`;
        }
        return accountId;
    }
}
tslib_1.__decorate([
    (0, class_validator_1.IsEnum)(apigw_models_1.Brand),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ example: 'essent', description: 'The brand of the hostname this request was sent to' }),
    tslib_1.__metadata("design:type", String)
], APIGatewayHeaders.prototype, "brand", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.MaxLength)(10),
    (0, class_validator_1.MinLength)(9),
    (0, class_validator_1.Matches)(/^\d+$/),
    (0, class_transformer_1.Expose)({ name: 'account-id' }),
    (0, apigw_models_1.Docs)({ example: '0100087729', description: 'The business partner id of the auth token' }),
    tslib_1.__metadata("design:type", String)
], APIGatewayHeaders.prototype, "accountId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'Account-ID' }),
    (0, apigw_models_1.Docs)({ example: '0100087729', description: 'The business partner id of the auth token' }),
    tslib_1.__metadata("design:type", String)
], APIGatewayHeaders.prototype, "cockpitAccountId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'source-system' }),
    (0, apigw_models_1.Docs)({ example: 'mijn', description: 'The source system of the request' }),
    tslib_1.__metadata("design:type", String)
], APIGatewayHeaders.prototype, "sourceSystem", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'user-scope' }),
    (0, apigw_models_1.Docs)({ example: apigw_models_1.UserScope.EMPLOYEE, description: 'The channel of the request' }),
    tslib_1.__metadata("design:type", String)
], APIGatewayHeaders.prototype, "userScope", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'oidc-scope' }),
    (0, apigw_models_1.Docs)({ example: 'openid', description: 'The scopes as listed in the users token' }),
    tslib_1.__metadata("design:type", String)
], APIGatewayHeaders.prototype, "oidcScope", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'employee-id' }),
    (0, apigw_models_1.Docs)({ example: 'openid', description: 'The UPN (KID) of the employee' }),
    tslib_1.__metadata("design:type", String)
], APIGatewayHeaders.prototype, "employeeId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'legacy-employee-id' }),
    (0, apigw_models_1.Docs)({ example: 'openid', description: 'The legacy UI ID of the employee' }),
    tslib_1.__metadata("design:type", String)
], APIGatewayHeaders.prototype, "legacyEmployeeId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'client-id' }),
    tslib_1.__metadata("design:type", String)
], APIGatewayHeaders.prototype, "clientId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'x-forwarded-jwt-claims' }),
    (0, apigw_models_1.Docs)({ example: '', description: 'The auth token' }),
    tslib_1.__metadata("design:type", String)
], APIGatewayHeaders.prototype, "token", void 0);
exports.APIGatewayHeaders = APIGatewayHeaders;
